import React from 'react';
import AhorroIcon from "../../assets/icons/m_ahorro.svg";
import AvanceNominaIcon from "../../assets/icons/m_avance_nomina.svg";
import BuzonIcon from "../../assets/icons/m_buzon.svg";
import CafeteriaIcon from "../../assets/icons/m_cafeteria.svg";
import CartaTrabajoIcon from "../../assets/icons/m_cartas_trabajo.svg";
import ComunidadIcon from "../../assets/icons/m_comunidad.svg";
import ContenedorPaginaIcon from "../../assets/icons/m_contenedor_pagina.svg";
import CursoIcon from "../../assets/icons/m_cursos.svg";
import DatoIcon from "../../assets/icons/m_datos.svg";
import DirectorioEmpleadoIcon from "../../assets/icons/m_directorio_empleados.svg";
import DocumentoIcon from "../../assets/icons/m_documentos.svg";
import EncuestaIcon from "../../assets/icons/m_encuestas.svg";
import GenericoIcon from "../../assets/icons/m_generico.svg";
import IncapacidadIcon from "../../assets/icons/m_incapacidades.svg";
import NoticiaIcon from "../../assets/icons/m_noticias.svg";
import PermisoIcon from "../../assets/icons/m_permisos.svg";
import PermisoHoraIcon from "../../assets/icons/m_permisos_por_hora.svg";
import PrenominaIcon from "../../assets/icons/m_prenomina.svg";
import PrestamoIcon from "../../assets/icons/m_prestamos.svg";
import ReciboIcon from "../../assets/icons/m_recibos.svg";
import ResguardoIcon from "../../assets/icons/m_resguardo.svg";
import ResumenAnualIcon from "../../assets/icons/m_resumen_anual.svg";
import SolicitudCartaCalculoAnualIcon from "../../assets/icons/m_solicitud_carta_calculo_anual.svg";
import SolicitudIcon from "../../assets/icons/m_solicitudes.svg";
import SupervisorIcon from "../../assets/icons/m_supervisores.svg";
import VacacionIcon from "../../assets/icons/m_vacaciones.svg";
import ValesSodexoIcon from "../../assets/icons/m_vales_sodexo.svg";
import VideoIcon from "../../assets/icons/m_videos.svg";
import Back from "../../assets/icons/back.svg";
import InicioFullIcon from "../../assets/icons/inicio-full.svg";
import InicioOutlinedIcon from "../../assets/icons/inicio-outlined.svg";
import NotificacionesFullIcon from "../../assets/icons/notificaciones-full.svg";
import NotificacionesOutlinedIcon from "../../assets/icons/notificaciones-outlined.svg";
import AyudaFullIcon from "../../assets/icons/ayuda-full.svg";
import AyudaOutlinedIcon from "../../assets/icons/ayuda-outlined.svg";
import CuentaFullIcon from "../../assets/icons/cuenta-full.svg";
import CuentaOutlinedIcon from "../../assets/icons/cuenta-outlined.svg";
import CerrarSesionFullIcon from "../../assets/icons/cerrar sesion-full.svg";
import CerrarSesionOutlinedIcon from "../../assets/icons/cerrar sesion-outlined.svg";
import AsistenciaRemotaIcon from "../../assets/icons/m_asistencia_remota.svg"


export function GetIconByName(name) {
	switch (name) {
		case "gi-contenedor":
			return ContenedorPaginaIcon;
		case "gi-file-money":
			return ReciboIcon;
		case "gi-course":
			return CursoIcon;
		case "gi-calendar":
			return PermisoIcon;
		case "gi-incapacity":
			return IncapacidadIcon;
		case "gi-suitcase":
			return VacacionIcon;
		case "gi-file-letter":
			return CartaTrabajoIcon;
		case "gi-contacts":
			return DirectorioEmpleadoIcon;
		case "gi-video":
			return VideoIcon;
		case "gi-prenomina":
			return PrenominaIcon;
		case "gi-prestamos":
			return PrestamoIcon;
		case "gi-ahorros":
			return AhorroIcon;
		case "gi-cafe":
			return CafeteriaIcon;
		case "gi-open-envelope":
			return BuzonIcon;
		case "gi-cart":
			return ValesSodexoIcon;
		case "gi-file-search":
			return SolicitudIcon;
		case "gi-tax-calculator":
			return ResumenAnualIcon;
		case "gi-noticias":
			return NoticiaIcon;
		case "gi-encuesta":
			return EncuestaIcon;
		case "gi-avance-nomina":
			return AvanceNominaIcon;
		case "gi-supervisores":
			return SupervisorIcon;
		case "gi-user":
			return DatoIcon;
		case "gi-documents":
			return DocumentoIcon;
		case "gi-cupones":
			return ComunidadIcon;
		case "gi-home":
			return InicioFullIcon;
		case "gi-home-outlined":
			return InicioOutlinedIcon;
		case "gi-notification":
			return NotificacionesFullIcon;
		case "gi-notification-outlined":
			return NotificacionesOutlinedIcon;
		case "gi-help":
			return AyudaFullIcon;
		case "gi-help-outlined":
			return AyudaOutlinedIcon;
		case "gi-account":
			return CuentaFullIcon;
		case "gi-account-outlined":
			return CuentaOutlinedIcon;
		case "gi-close-session-outlined":
			return CerrarSesionOutlinedIcon;
		case "gi-close-session":
			return CerrarSesionFullIcon;
		case "gi-request-anaual":
			return SolicitudCartaCalculoAnualIcon;
		case "gi-back":
			return Back;
		case "gi-resguardo":
			return ResguardoIcon;
		case "gi-permiso-hora":
			return PermisoHoraIcon;
		case "gi-asistencia-remota":
  		    return AsistenciaRemotaIcon;
		default:
			return GenericoIcon;
	}
}

export function GetIconById(id) {
	switch (id) {
		case 0:
			return GetIconByName("gi-contenedor");
		case 1:
			return GetIconByName("gi-file-money");
		case 2:
			return GetIconByName("gi-course");
		case 3:
			return GetIconByName("gi-calendar");
		case 4:
			return GetIconByName("gi-incapacity");
		case 5:
			return GetIconByName("gi-suitcase");
		case 11:
			return GetIconByName("gi-suitcase");
		case 12:
			return GetIconByName("gi-file-letter");
		case 13:
			return GetIconByName("gi-contacts");
		case 14:
			return GetIconByName("gi-open-envelope");
		case 15:
			return GetIconByName("gi-video");
		case 16:
			return GetIconByName("gi-prenomina");
		case 17:
			return GetIconByName("gi-prestamos");
		case 18:
			return GetIconByName("gi-ahorros");
		case 19:
			return GetIconByName("gi-file-search");
		case 20:
			return GetIconByName("gi-cafe");
		case 21:
			return GetIconByName('gi-cupones');
		case 22:
			return GetIconByName('gi-user');
		case 23:
			return GetIconByName('gi-tax-calculator');
		case 24:
			return GetIconByName('gi-promociones');
		case 25:
			return GetIconByName('gi-star');
		case 28:
			return GetIconByName('gi-noticias');
		case 29:
			return GetIconByName("gi-encuesta");
		case 101:
			return GetIconByName("gi-cart");
		case 103:
			return GetIconByName("gi-avance-nomina");
		case 104:
			return GetIconByName("gi-supervisores");
		case 106:
			return GetIconByName("gi-documents");
		case 109:
  		    return GetIconByName("gi-asistencia-remota");
		default:
			return GetIconByName("gi-generico");
	}
}

export function FontIcon({ className = "", ...props }) {
	return <span className={className} {...props}></span>
}

export function HomeFullIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-inicio-full ${className}`} {...props} />
}

export function HomeOutlinedIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-inicio-outlined ${className}`} {...props} />
}

export function NotificationFullIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-notificaciones-full ${className}`} {...props} />
}

export function NotificationOutlinedIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-notificaciones-outlined ${className}`} {...props} />
}

export function HelpFullIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-ayuda-full ${className}`} {...props} />
}

export function HelpOutlinedIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-ayuda-outlined ${className}`} {...props} />
}

export function AccountFullIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-cuenta-full ${className}`} {...props} />
}

export function AccountOutlinedIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-cuenta-outlined ${className}`} {...props} />
}

export function LogOutFullIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-cerrar-sesion-full ${className}`} {...props} />
}

export function LogOutOutlinedIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-cerrar-sesion-outlined ${className}`} {...props} />
}

export function SuccessFullIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-success-full ${className}`} {...props} />
}

export function SuccessOutlinedIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-success-outline ${className}`} {...props} />
}

export function ErrorFullIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-error-full ${className}`} {...props} />
}

export function ErrorOutlinedIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-error-outline ${className}`} {...props} />
}

export function InfoFullIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-info-full ${className}`} {...props} />
}

export function InfoOutlinedIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-info-outline ${className}`} {...props} />
}

export function WarningFullIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-warning-full ${className}`} {...props} />
}

export function WarningOutlinedIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-warning-outline ${className}`} {...props} />
}

export function ShowPassIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-mostrar-contrasena ${className}`} {...props} />
}

export function HidePassIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-ocultar-contrasena ${className}`} {...props} />
}

export function ArrowDownIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-Abajo ${className}`} {...props} />
}

export function ArrowUpIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-Arriba ${className}`} {...props} />
}

export function ArrowRightIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-Derecha ${className}`} {...props} />
}

export function BackIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-Back ${className}`} {...props} />
}

export function CloseIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-close ${className}`} {...props} />
}

export function SearchIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-Search ${className}`} {...props} />
}

export function AlertIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-Alerta ${className}`} {...props} />
}

export function PlusIcon({ className = "", ...props }) {
	return <FontIcon className={`icon-plus ${className}`} {...props} />
}